export const MEDIA_GROUP_PLAYLIST = 'media-group-list';
export const LANDING_PAGE_LIST = 'landing-page-list';
export const APP_SECTION_LIST = 'app-section-list';
export const PROFILE_REWARD__LIST = 'profile-reward-list';
export const WHEEL_LIST = 'wheel-list';
export const WHEEL_ITEM_LIST = 'wheel-item-list';
export const TRANSACTION_PACKAGE_LIST = 'transaction-package-list';
export const GAME_ENTRY_FEE_LIST = 'game-entry-fee-list';
export const RTMP_LIST_VOD = 'rtmp-list-vod';
export const RTMP_LIST = 'rtmp-list';
export const APP_DUAL_LIST = 'app-duel-list';
export const APP_MEDIA_REWARDS_LIST = 'app-media-rewards-list';
export const APP_BANNER_LIST = 'app-banner-list';
export const GAME_JOIN_PLAYLIST_LIST = 'game-join-playlist-list';
export const USER_LIST = 'user-list';
export const PROJECT_FEED_LIST = 'project-feed-list';
export const GAME_JOIN_LIST = 'game-join-list';
export const FEED_ITEM_LIST = 'feed-item-list';
export const GATEWAY_LIST = 'gateway-list';
export const GATEWAY_PROFILE_LIST = 'gateway-profile-list';
export const GATEWAY_JOIN_PROFILE_LIST = 'gateway-join-profile-list';
export const FOOTBALLOP_GAME_CARD_LIST = 'footballop-game-card-list';
export const SOCIAL_MANAGER_ACCOUNT_LIST = 'social-manager-account-list';
export const SOCIAL_MANAGER_CHANNEL_LIST = 'social-manager-channel-list';
export const SOCIAL_MANAGER_CONTENT_LIST = 'social-manager-content-list';
export const GAME_LIST = 'game-list';
export const AVATAR_LIST = 'avatar-list';
export const TRANSACTION_EXCHANGE_CONFIG_LIST = 'tansaction-exchange-config-list';
export const SOCIAL_MANAGER_CONTENT_TYPE_LIST = 'social-manager-channel-type-list';
export const SOCIAL_MANAGER_CONTENT_TYPES_STATUS = 'social-manager-content-types-status';
export const APP_VERSION_CONTROL_LIST = 'app-verstion-control-list';
export const GAME_ENTRY_FEE_REWARD = 'game-entry-fee-reward';
export const DUEL_GROUP = 'duel-group';
export const MEDIA_SOCIAL_PLAYER_LIST = 'media-social-player-list';
export const COMMENT_LIST = 'comment-list';
export const SUBSCRIBE_PACKAGE_LIST = 'subscribe-package-list';
export const SUBSCRIBE_GIFT_LIST = 'subscribe-gift-list';
export const SUBSCRIBE_GIFT_INDEX = 'subscribe-gift-index';
export const SUBSCRIBE_GIFT_GENERATE = 'subscribe-gift-generate';
export const SUBSCRIBE_PACKAGE_TYPE_LIST = 'subscribe-package-type-list';
export const SUBSCRIBE_PACKAGE_POSITION_LIST = 'subscribe-package-position-list';
export const DOMAIN_FORM = 'domain-form';
export const HOST_FORM = 'host-form';
export const SUBMENU_ITEM = 'submenu-item';
export const TRANSACTION_AMOUNT_TYPE_LIST = 'transaction-amount-type';
export const NOTIFICATION_STYLE_LIST = 'notification-style-list';
export const NOTIFICATION_POPUP_LIST = 'notification-popup-list';
export const PRODUCT_TYPE = 'product-type';

// CONTENT_HUB

export const WIKI_MEDIA_LIST = 'wiki-media-list';
export const MEDIA_SCORE_LIST = 'media-score-list';
export const MEDIA_PROVIDE_LIST = 'media-provide-list';
export const MEDIA_SUBTITLE_LIST = 'media-subtitle-list';
export const UPLOAD_TO_SERVER_LIST = 'upload-to-server-list';
export const MEDIA_JOIN_TAG_LIST = 'media-join-tag-list';

// GAME_HUB

export const GAME_PREVIEW_LIST = 'game-preview-list';
export const GAME_Wiki_LIST = 'game-wiki-list';
export const GAME_ARTIST_LIST = 'game-artist-list';
export const ADD_NEW_GAME_ARTIST = 'add-new-game-artist';

export const MEDIA_COOPERATION_LIST = 'media-cooperation-list';
export const MEDIA_COOPERATION_SCRIPT = 'media-cooperation-script';
